<template>
  <v-col
    class="d-flex"
    cols="12"
    sm="6"
  >
    <v-select
      :items="items"
      v-model="selection"
      label="Sort by"
      dense
      outlined
    ></v-select>
  </v-col>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    items: [
      { value: { sort: 'date', desc: true }, text: 'Newest' },
      { value: { sort: 'date', desc: false }, text: 'Oldest' },
      { value: { sort: 'views', desc: true }, text: 'Most viewed' },
      { value: { sort: 'views', desc: false }, text: 'Less viewed' },
      { value: { sort: 'random', desc: false }, text: 'Random' }
    ]
  }),
  computed: {
    selection: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
